interface HeadingProps {
    inverted?: boolean
    children: string
}

export default ({inverted =false, children} : HeadingProps) => {
    return(
        <h2 className={`font-heading text-3xl mb-5 ${inverted ? 'text-white': ''}`}>{children}</h2>
    )
}